import React from 'react';

const ImageViewerModal = ({ src, alt, onClose }) => {
  if (!src) return null;

  return (
    <div className="image-viewer-overlay" onClick={onClose}>
      <button className="image-viewer-close-btn" onClick={onClose}>
        &times;
      </button>
      <div className="image-viewer-content" onClick={(e) => e.stopPropagation()}>
        <img src={src} alt={alt || 'Enlarged product view'} className="image-viewer-img" />
      </div>
    </div>
  );
};

export default ImageViewerModal;